import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import "@github/relative-time-element";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { Helmet } from 'react-helmet';
import ReactTimeAgo from 'react-time-ago';
import ReactDOMServer from "react-dom/server";
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/es'; // Importa todos los locales que necesites (por ejemplo, 'es' para español)
import './irregularity_types.css';
import DeletedIrregularity from './deleted-irregularity_types';




function Irregularity({ handleMenuClick }) {
    const [entries, setEntries] = useState([]);
    const [updateTrigger, setUpdateTrigger] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setDataPerPage] = useState(10);
    const [loading, setLoading] = useState(true);
    const [searchValue, setSearchValue] = useState("");
    const [showDeleted, setShowDeleted] = useState(false);
  
    const filteredData = searchValue
    ? entries.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase()) ||
        data.code.toUpperCase().includes(searchValue.toUpperCase()) 
      )
    : entries;

  
    const indexOfLastData = currentPage * dataPerPage;
    const indexOfFirstData = indexOfLastData - dataPerPage;
  
    const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);
  
    const paginate = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
  
    const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
    const pageNumbers = [];
    const maxPageNumbersToShow = 20;
  
    let startPage, endPage;
    if (totalPageCount <= maxPageNumbersToShow) {
      startPage = 1;
      endPage = totalPageCount;
    } else {
      startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
      endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);
  
      if (endPage - startPage < maxPageNumbersToShow) {
        startPage = endPage - maxPageNumbersToShow + 1;
      }
    }
  
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
  
    const showEntries = (e) => {
      setDataPerPage(e.target.value);
    };
  
    const getEntries = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/irregularity_types`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          });
          if (res.data.code === 1) {
            setEntries(res.data.data);
            setLoading(false);
          } else {
            Swal.fire("Error", "Hubo un error al obtener los datos", "error");
            setLoading(false);
          }
        } catch (error) {
          Swal.fire("Error", "Hubo un error al obtener los datos", "error");
          setLoading(false);
        }
      }; 
  
    const deleteEntries = async (id) => {
      try {
        const result = await Swal.fire({
          title: "¿Estás seguro?",
          text: "¡No podrás revertir esto!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminarlo",
          cancelButtonText: "No, cancelar",
          reverseButtons: true,
          buttonsStyling: true,
        });
        if (result.isConfirmed) {
          await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/irregularity_types/destroy/${id}`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          });
          Swal.fire("¡Eliminado!", "El elemento ha sido eliminado.", "success");
          setUpdateTrigger(!updateTrigger);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelado");
        }
      } catch (error) {
        Swal.fire("Error", "Hubo un error", "error");
      }
    };
  
    const updateEntries = async (id) => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/irregularity_types/find/${id}`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          });
          const entryData = response.data.data; // Accediendo a los datos correctos
      

          const reactComponentHtml = ReactDOMServer.renderToString(
            <>
                <form
                    acceptCharset="UTF-8"
                    id="formValidation"
                    className="form-horizontal fv-form fv-form-bootstrap"
                    autoComplete="off"
                    encType="multipart/form-data"
                    noValidate="novalidate"
                >
                    <div className="row mb-3 text-start">
                        <div className="col-md-6">
                            <label htmlFor="name">Nombre *</label>
                            <input type="text" className="form-control" id="name" placeholder="Nombre" value={entryData[0].name} />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="code">Código *</label>
                            <input type="text" className="form-control" id="code" placeholder="Código" value={entryData[0].code} />
                        </div>
                    </div>
                      
                </form>
            </>
        );
        const result = await Swal.fire({
            title: "Editar Irregularidad",
            html: reactComponentHtml,
            showDenyButton: true,
            confirmButtonText: "Actualizar",
            denyButtonText: "Cancelar",
            width: 1000,
            padding: "1px",
            color: "#000",
            backdrop: `
                rgba(0,0,0,0.8)
            `,
            customClass: {
                confirmButton: "btn-amc-blue",
                denyButton: "btn-cancel",
                title: "alert-title",
                popup: "alert-bg",
            },
            preConfirm: function () {
                const name = document.getElementById("name").value;
                const code = document.getElementById("code").value;
                

                if (!name || !code ) {
                  Swal.showValidationMessage("Todos los campos son obligatorios");
                return false;
                }
        
                return {
                  name, code
                };
            },
        });

      
          if (result.isConfirmed) {
            const updatedUserData = result.value;
            const updateResponse = await axios.post(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/irregularity_types/update/${id}`,
              updatedUserData,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
              }
            );
      
            Swal.fire(
              "¡Actualizado!",
              "El elemento ha sido actualizado exitosamente.",
              "success"
            );
            setUpdateTrigger(!updateTrigger);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire(
              "Cancelado",
              "No se ha realizado ninguna actualización.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error:", error); // Depuración
          Swal.fire("Error", "Hubo un error al actualizar", "error");
        }
      };      

    const createEntries = async () => {
      try {
          const reactComponentHtml = ReactDOMServer.renderToString(
              <>
                  <form
                      acceptCharset="UTF-8"
                      id="formValidation"
                      className="form-horizontal fv-form fv-form-bootstrap"
                      autoComplete="off"
                      encType="multipart/form-data"
                      noValidate="novalidate"
                  >
                      <div className="row mb-3 text-start">
                          <div className="col-md-6">
                              <label htmlFor="name">Nombre *</label>
                              <input type="text" id="name" class="form-control" placeholder="Nombre" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')" />
                          </div>
                          <div className="col-md-6">
                              <label htmlFor="code">Código *</label>
                              <input type="text" id="code" class="form-control" placeholder="Código" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')" />
                          </div>
                          
                      </div>
                  </form>
              </>
          );
          
          const result = await Swal.fire({
              title: "Agregar Irregularidad",
              html: reactComponentHtml,
              showDenyButton: true,
              confirmButtonText: "Guardar",
              denyButtonText: "Cancelar",
              width: 1000,
              padding: "1px",
              color: "#000",
              backdrop: `
                  rgba(0,0,0,0.8)
              `,
              customClass: {
                  confirmButton: "btn-amc-blue",
                  denyButton: "btn-cancel",
                  title: "alert-title",
                  popup: "alert-bg",
              },
              preConfirm: function () {
                  const name = document.getElementById("name").value;
                  const code = document.getElementById("code").value;
          
                  if (!name || !code ) {
                    Swal.showValidationMessage("Todos los campos son obligatorios");
                  return false;
                  }
          
                  return {
                    name, code, 
                  };
              },
          });

          if(result.isConfirmed){
              const Data = result.value;

              const createResponse = await axios.post(
                  `${process.env.REACT_APP_URL_BACKEND}/api/v1/irregularity_types/store`,
                  Data,
                  {
                  headers: {
                      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                  },
                  }
              );

              Swal.fire(
                  "¡Creado!",
                  "El elemento ha sido registrado exitosamente.",
                  "success"
              );
              setUpdateTrigger(!updateTrigger);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.fire("Cancelado", "Acción cancelada.", "error");
          }
      } catch (error) {
          console.error(error);
          Swal.fire("Error", "Hubo un error", "error");
      }
  };


    const handleSearch = () => {
        const input = document.getElementById("searchInput");
        setSearchValue(input.value.trim());
      };
  
    useEffect(() => {
      getEntries();
    }, [updateTrigger]);

  return (
    <>
      <Helmet>
        <title>Horus | Irregularidades </title>
      </Helmet>
      <ScrollToTop />
      <div className="table-responsive">
        <div className="dataTables_wrapper dt-bootstrap4 no-footer container-fluid" id="datatables_wrapper">
          <div className="text-right mb-2 ">
              <button className="btnn" onClick={() => setShowDeleted(!showDeleted)}>
                  {showDeleted ? "Ver Activos" : "Ver Eliminados"}
              </button>   
          </div>
              {showDeleted ? (
                  <DeletedIrregularity setUpdateTrigger={setUpdateTrigger} updateTrigger={updateTrigger} />
              ) : (
              <>
                <div className="text-right mb-4 ">
                  <button
                    className="btnn"
                    onClick={createEntries}
                  >
                    Añadir Irregularidad
                  </button>
                </div>
                <div className="row justify-content-between mb-2">
                  <div className="col-sm-12 col-md-4">
                    <div className="dataTables_length mb-2" id="dataTables_length">
                        <label className="d-flex justify-content-start">
                        <span className="mr-2 p-2">Mostrar</span>
                        <select
                            name="datatables_length"
                            aria-controls="datatables_length"
                            className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                            onChange={showEntries}
                        >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                        <span className="ml-2 p-2">registros</span>
                        </label>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <div className="datatables_filter" id="datatables_filter">
                        <label className="d-flex justify-content-end">
                        <input
                            type="search"
                            id="searchInput"
                            className="form-control form-control-sm"
                            placeholder="Buscar..."
                            aria-controls="datatables"
                        />
                        <button className="btnn" onClick={handleSearch}>
                            Buscar
                        </button>
                        </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                                <div className="col-sm-12">
                                    <table
                                        className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                                        role="grid"
                                        aria-describedby="datatables_info"
                                    >
                                        <thead>
                                            <tr>
                                                <th>
                                                    Nombre
                                                </th>
                                                <th>
                                                    Código
                                                </th>
                                                <th>
                                                    Acciones
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                               {currentData.map((entry) => (
                                              <tr key={entry.id} data-master-id={entry.id}>
                                                <td>{entry.name}</td>
                                                <td>{entry.code}</td>
                                                <td>
                                                <FaEdit className='editButton' onClick={() => { updateEntries(entry.id) }} />
                                                <FaTimes className='deleteButton' onClick={() => { deleteEntries(entry.id) }} />
                                                </td>
                                              </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                <div className="row">
                  <nav aria-label="Page navigation example">
                    <ul className="pagination">
                      <li className="page-item">
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Anterior
                        </button>
                      </li>
                      {pageNumbers.map((pageNumber) => (
                        <li className="page-item" key={pageNumber}>
                          <button
                            className="page-link"
                            onClick={() => paginate(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      ))}
                      <li className="page-item">
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                          disabled={currentPage === pageNumbers.length}
                        >
                          Siguiente
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div> 
              </>      
          )} 
        </div>
      </div>
    </>
  );
}

export default Irregularity;